/**
 * @namespace buy-fulfillment_offerings-v1
 * @description Mapping of crc error codes for buy/fulfillment_offerings/v1 using service error codes
 * @memberof ux-tread-crc-code
 *
 * @property {string} 500 - 9060A8E5 WHEN SERVICE IS EXPERIENCING SYSTEM ERRORS
 * @property {string} NOT_FOUND - 9576520D If a product doesn't exist or unavailable or if no fulfillment offerings found for ALL SKUs of the product.
 * @property {string} VALIDATION_ERROR - 957C63A0 If required request filters are missing or invalid.
 * @property {string} INVALID_FILTER_VALUE - 36A1E761 No docs provided but indicating invalid filter values provided via query params
 * @property {string} FORBIDDEN - B9A23D28 If any downstream requests get rejected, e.g. a bot attack detected.
 * @property {string} INTERNAL_SERVER_ERROR - 2CC329A9 If the service caught an unhandled exception.
 */

module.exports = {
  500: '9060A8E5',
  NOT_FOUND: '9576520D',
  VALIDATION_ERROR: '957C63A0',
  INVALID_FILTER_VALUE: '36A1E761',
  FORBIDDEN: 'B9A23D28',
  INTERNAL_SERVER_ERROR: '2CC329A9',
};
